import { render, staticRenderFns } from "./MyTenders.vue?vue&type=template&id=38458f2e"
import script from "./MyTenders.vue?vue&type=script&lang=js"
export * from "./MyTenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports